import {RequestResponsePayload} from '../../../models/api';

export default [
  {
    id: 111,
    isRead: false,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T13:45Z',
  },
  {
    id: 110,
    isRead: true,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T13:24Z',
  },
  {
    id: 109,
    isRead: false,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T12:47Z',
  },
  {
    id: 108,
    isRead: true,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T12:44Z',
  },
  {
    id: 107,
    isRead: false,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T12:40Z',
  },
  {
    id: 106,
    isRead: true,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T12:36Z',
  },
  {
    id: 105,
    isRead: false,
    topic: 'Вопрос по карте ЕСК',
    dateTime: '2020-06-09T12:35Z',
  },
  {
    id: 104,
    isRead: true,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-09T12:29Z',
  },
  {
    id: 102,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-09T12:17Z',
  },
  {
    id: 101,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-09T12:16Z',
  },
  {
    id: 100,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-09T12:14Z',
  },
  {
    id: 99,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-09T12:12Z',
  },
  {
    id: 97,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:57Z',
  },
  {
    id: 96,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:57Z',
  },
  {
    id: 95,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:57Z',
  },
  {
    id: 94,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:47Z',
  },
  {
    id: 93,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:45Z',
  },
  {
    id: 92,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:45Z',
  },
  {
    id: 91,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:45Z',
  },
  {
    id: 90,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:42Z',
  },
  {
    id: 89,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:42Z',
  },
  {
    id: 88,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:42Z',
  },
  {
    id: 87,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:41Z',
  },
  {
    id: 86,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:41Z',
  },
  {
    id: 85,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:40Z',
  },
  {
    id: 84,
    isRead: false,
    topic: 'Вопрос по льготам и их начислению',
    dateTime: '2020-06-09T10:40Z',
  },
  {
    id: 83,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-09T10:37Z',
  },
  {
    id: 52,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-08T09:37Z',
  },
  {
    id: 51,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-08T09:33Z',
  },
  {
    id: 50,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-08T09:30Z',
  },
  {
    id: 49,
    isRead: false,
    topic: 'Вопрос по банковскому приложению',
    dateTime: '2020-06-08T09:23Z',
  },
] as RequestResponsePayload[];
